export default __webpack_public_path__ + "static/media/pc.78de92e8.png";